import actions from './actions'
import mutations from './mutations'
import state from './state'

export const applicationFieldTracking = {
  namespaced: true,
  actions,
  mutations,
  state
}
